<div class="modal-header">
  <h4 class="modal-title">
    @if (survey) {
      Editar encuesta
    }
    @if (!survey) {
      Nueva encuesta
    }
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  @if (!loading) {
    <form
      id="formSurvey"
      [formGroup]="formSurvey"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @for (key of utilService.objectKeys(dataForm); track key) {
            @if (
              dataForm[key].type == "text"
            ) {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }

            @if (dataForm[key].type === 'textarea') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <textarea
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }"></textarea>
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }

            @if (dataForm[key].type === 'switch') {
              <div class="col-12 mt-2 mb-4">
                <div class="row">
                  <div class="col-8">
                    {{ dataForm[key].label }}
                  </div>
                  <div class="col-4 text-end">
                    <p-inputSwitch
                      formControlName="{{ key }}">
                    </p-inputSwitch>
                  </div>
                </div>
              </div>
            }

            @if(dataForm[key].type === 'datetime') {

              <div class="col-12 mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <p-calendar
                  styleClass="w-100"
                  [ngClass]="{
                    'ng-invalid ng-dirty': submitted && f[key].errors && dataForm[key].required
                  }"
                  inputId="calendar-24h" 
                  formControlName="{{ key }}"
                  [showTime]="true" 
                  hourFormat="24" />
              </div>

            }

          }

          @if(survey) {

            @if(!survey.status) {

              <div class="col-12 text-danger">
                Una vez publicada esta encuensta ya no podrá editarla.
              </div>

            }

          }

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formSurvey"
      class="btn btn-primary w-100">
      {{ survey ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
